import React from 'react';
import SEO from '../components/SEO';

const patterns = [
  {
    number: 1,
    title: 'There is a source beyond comprehension',
    description:
      'Every tradition points to something infinite, unnamed, beyond the reach of language. The Tao that can be spoken is not the eternal Tao. God is not what you think God is. The source is real, but it cannot be captured in a jar.',
  },
  {
    number: 2,
    title: 'Consciousness is fundamental, not matter',
    description:
      'The universe is not a machine that accidentally produced awareness. Awareness is woven into the fabric of reality. The observer is not separate from what is observed. Quantum physics and ancient mystics arrive at the same door.',
  },
  {
    number: 3,
    title: 'Separation is less fundamental than connection',
    description:
      'The feeling of being a separate self in a hostile universe is the deepest illusion. Beneath the surface, everything is interconnected. What happens to one, happens to all. The mystics called it unity. Physics calls it entanglement.',
  },
  {
    number: 4,
    title: 'The ego / false self is the root of suffering',
    description:
      'Suffering is not caused by pain. It is caused by the story the ego tells about pain. The false self clings, compares, fears, and fights. Every tradition says the same thing: the prison is self-made.',
  },
  {
    number: 5,
    title: 'Letting go is the path to freedom',
    description:
      'Not grasping. Not forcing. Not accumulating. Freedom comes from releasing, not from acquiring. Surrender is not weakness. It is the ultimate strength. Let go, and what remains is what was always there.',
  },
  {
    number: 6,
    title: 'The present moment is the only point of entry',
    description:
      'The past is memory. The future is imagination. The only place where life actually happens is now. Every spiritual practice, at its core, is a method for returning to this moment. This breath. This step.',
  },
  {
    number: 7,
    title: 'When the ego quiets, what remains is love',
    description:
      'Not romantic love. Not transactional love. Something deeper. When the noise of the self falls away, what remains is a quiet, boundless compassion. Every tradition that goes deep enough arrives here.',
  },
];

export default function Patterns() {
  return (
    <div className="min-h-screen pt-24 pb-20 px-6">
      <SEO path="/patterns" />
      <div className="max-w-2xl mx-auto">
        <h1 className="font-serif text-3xl md:text-4xl text-warm text-center mb-4">
          The Seven Patterns
        </h1>
        <p className="text-warm-100/50 text-center mb-16 font-serif italic">
          Observed across all major wisdom traditions
        </p>

        <div className="space-y-12">
          {patterns.map((p) => (
            <div
              key={p.number}
              className="border-l-2 border-gold/20 pl-6 py-2 hover:border-gold/40 transition-colors"
            >
              <div className="flex items-baseline gap-3 mb-3">
                <span className="text-gold/40 font-serif text-3xl">{p.number}</span>
                <h2 className="font-serif text-xl text-warm leading-snug">
                  {p.title}
                </h2>
              </div>
              <p className="text-warm-100/60 leading-relaxed">
                {p.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <p className="text-warm-100/40 text-sm font-serif italic leading-relaxed max-w-md mx-auto">
            These patterns are observed, not declared. Use them if they help. Improve them if you can.
          </p>
        </div>
      </div>
    </div>
  );
}
